import { cn } from '@tripleten/cn';

export const cnVisuallyHidden = cn('visually-hidden');
